<template>
<div class="chapter">
<div class="inner_page">
<h1 class="half"><a id="page_2"></a>THE BATTLES FOR</h1>
<h1 class="half1">MONTE CASSINO</h1>
<h1 class="half2">THEN AND NOW</h1>
<div class="img_container"><a id="page_3"></a>
<img alt="Images" src="images/f0002-1.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?19069075